import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';

import RichText from '@/app/components/RichText';

const MembersSection = () => {
  return (
    <section className="py-10 lg:py-20" data-cy="members-section">
      <LayoutGrid rowGap={24}>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <Typography
            variant="eyebrow-large"
            Element="h2"
            weight="bold"
            align="center"
            className="uppercase"
          >
            <RichText messageKey="oura_app" />
          </Typography>
        </GridItem>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <Typography
            variant="h1"
            Element="h3"
            className="px-6 leading-tighter"
            align="center"
            font="serif"
          >
            <RichText messageKey="membership_redesign_members_title" />
          </Typography>
        </GridItem>
        <GridItem
          colEnd={{ sm: 'main', lg: 19 }}
          colStart={{ sm: 'main', lg: 7 }}
        >
          <Typography
            variant="h5"
            Element="p"
            className="leading-tight tracking-tight lg:text-center lg:tracking-tighter"
          >
            <RichText messageKey="membership_redesign_members_copy" />
          </Typography>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default MembersSection;
